import { useCentralizedProviderData } from '@crehana/auth';
import { useKnowledgeHubConfigQuery } from '@crehana/compass.knowledgehub/hooks';

export const useAssignContentLeaderFeature = () => {
  const { me, loading: isLoadingMe } = useCentralizedProviderData();
  const organizationId = me?.security?.learningSession?.organizationId;

  const { configAdmin, loading: isLoadingConfigAdmin } =
    useKnowledgeHubConfigQuery({
      orgId: String(organizationId),
      skip: !organizationId || isLoadingMe,
    });

  const isLoading = isLoadingMe || isLoadingConfigAdmin;
  const isUserLeader =
    me?.security.applicationRoles?.includes('ROLE_LEADER') ?? false;
  const isAssignContentLeaderEnabled =
    isUserLeader && !!configAdmin?.assignContent;

  return {
    isAssignContentLeaderEnabled,
    isLoadingAssignContentLeaderEnabled: isLoading,
  };
};
